
import { AfterViewInit, ChangeDetectionStrategy, Component, effect, EffectRef, input, InputSignal, output, OutputEmitterRef, Signal, viewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule, NgForm, ReactiveFormsModule, UntypedFormControl, ValidationErrors } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { AlertComponent } from '@libs/common/components';
import { ErrorStateMatcher as FormErrorStateMatcher, MarkupComponent, SubmitGroupComponent, TextComponent } from '@libs/form/components';
import { MarkupItemModel, SubmitGroupItemModel, TextInputModel } from '@libs/form/models';
import { Subscription } from 'rxjs';
import { EmailConfirmItem, EmailItem, EmailNewItem, MarkupItem, SubmitGroupItem } from './user-email.model';

@Component({
  selector: 'ui-user-email',
  templateUrl: './user-email.component.html',
  styleUrls: ['./user-email.component.scss'],
  providers: [
    { provide: ErrorStateMatcher, useClass: FormErrorStateMatcher },
  ],
  imports: [
    TextComponent,
    SubmitGroupComponent,
    ReactiveFormsModule,
    MarkupComponent,
    FormsModule,
    AlertComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserEmailComponent implements AfterViewInit {
  private readonly ngForm: Signal<NgForm> = viewChild.required<NgForm>('form');
  private readonly updateValiditySubscription: Subscription;
  private readonly syncEmailEffect: EffectRef;

  public readonly email: InputSignal<string | undefined> = input<string | undefined>();
  public readonly hasPending: InputSignal<boolean | null | undefined> = input<boolean | null | undefined>();
  public readonly submitResult: OutputEmitterRef<string> = output<string>();

  public itemEmailCurrent: TextInputModel = EmailItem;
  public itemMarkup: MarkupItemModel = MarkupItem;
  public itemEmailNew: TextInputModel = EmailNewItem;
  public itemEmailConfirm: TextInputModel = EmailConfirmItem;
  public itemSubmit: SubmitGroupItemModel = SubmitGroupItem;

  public readonly emailCurrentControl: UntypedFormControl = new UntypedFormControl();
  public readonly emailNewControl: UntypedFormControl = new UntypedFormControl();
  public readonly emailConfirmControl: UntypedFormControl = new UntypedFormControl();

  public constructor() {
    this.updateValiditySubscription = this.emailNewControl.valueChanges.pipe(takeUntilDestroyed()).subscribe(() => {
      this.emailConfirmControl.updateValueAndValidity();
    });

    this.syncEmailEffect = effect(() => {
      const _hasPending: boolean | null | undefined = this.hasPending();
      const email: string | undefined = this.email();

      this.emailCurrentControl.setValue(email);
      this.ngForm().resetForm();
    });
  }

  public ngAfterViewInit(): void {
    this.emailConfirmControl.addValidators(this.validateRepeat.bind(this));
  }

  public onSubmit(): void {
    if (this.emailConfirmControl.valid) {
      this.submitResult.emit(String(this.emailNewControl.value));
    }
  }

  private validateRepeat(): ValidationErrors | null {
    if (this.emailNewControl.value === this.emailConfirmControl.value) {
      return null;
    }

    return {
      emailRepeat: true,
    };
  }
}
